export const Colors = {
	primary: '#00295D',
}